import { createFileRoute } from '@tanstack/react-router'

import { CoreSkillsAssessmentStepPollDynamic } from '@/core-skills-assessment/components/CoreSkillsAssessmentStepPollDynamic/CoreSkillsAssessmentStepPollDynamic'

export const Route = createFileRoute('/skills-assessment/poll-dynamic')({
  component: CoreSkillsAssessmentStepPollDynamic,
})
